export default __webpack_public_path__ + "static/media/icon-filter.16940c7d.svg";